module.exports = __webpack_public_path__ + "./images/c14c4179ae7137fdf67528a3821b7095.webp";